 import TRADCENTER from '@/api/module/trading.js';
 const TRADING = {
   namespaced: true,
   state: {
     payChannelList: [],
     payWayList: [],
     payBillList: [],
     total: 0,
     billInfo: {},
     ordersPrice: 0,
     count: 0  //订单数
   },
   mutations: {
     payChannelList(state, data = {}) {
       state.payChannelList = data;
     },
     payWayList(state, data = {}) {
       state.payWayList = data;
     },
     payBillList(state, data = {}) {
       state.payBillList = data.records;
       state.ordersPrice = data.ordersPrice;
       state.count = data.records.length;
       state.total = data.total;
     },
     billInfo(state, data = {}) {
       state.billInfo = data;
     },
   },
   actions: {
     // 查询当前应用下的渠道
     async queryPayChannel({
       commit
     }, params = {}) {
       try {
         const result = await TRADCENTER.queryPayChannel(params);
         commit('payChannelList', result);
         return Promise.resolve(result);
       } catch (err) {
         return Promise.reject(err);
       }
     },
     // 查询渠道下的支付方式
     async queryPayWay({
       commit
     }, params = {}) {
       try {
         const result = await TRADCENTER.queryPayWay(params);
         commit('payWayList', result);
         return Promise.resolve(result);
       } catch (err) {
         return Promise.reject(err);
       }
     },
     // 交易订单列表
     async queryPayBill({
       commit
     }, params = {}) {
       try {
         const result = await TRADCENTER.queryPayBill(params);
         commit('payBillList', result);
         return Promise.resolve(result);
       } catch (err) {
         return Promise.reject(err);
       }
     },
     // 交易订单详情
     async getBillById({
       commit
     }, params = {}) {
       try {
         const result = await TRADCENTER.getBillById(params);
         commit('billInfo', result);
         return Promise.resolve(result);
       } catch (err) {
         return Promise.reject(err);
       }
     },
   },
   getters: {

   },
 };

 export default TRADING;